// 9fbef606107a605d69c0edbcd8029e5d
import { fromJS } from 'immutable';
import PRODUCT_PICKUP_ACTIONS_CONSTANTS from '../ProductPickup.constants';

const initialState = {
  bopisInventoryDetails: {},
  recommendationsBopisInventoryDetails: {},
};

const ProductPickupReducer = (state = fromJS(initialState), action) => {
  switch (action.type) {
    case PRODUCT_PICKUP_ACTIONS_CONSTANTS.SET_BOPIS_INVENTORY:
      return state.set('bopisInventoryDetails', action.payload);
    case PRODUCT_PICKUP_ACTIONS_CONSTANTS.SET_RECOMM_BOPIS_INVENTORY:
      return state.set('recommendationsBopisInventoryDetails', action.payload);
    case PRODUCT_PICKUP_ACTIONS_CONSTANTS.SET_CHANGED_SELECTED_STORE:
      return state.set('changedSelectedStore', action.payload.pickupSelectedStore);
    case PRODUCT_PICKUP_ACTIONS_CONSTANTS.RESET_CHANGED_SELECTED_STORE:
      return state.set('changedSelectedStore', {});
    case PRODUCT_PICKUP_ACTIONS_CONSTANTS.FROM_AVAILABLE_STORES_CLICK:
      return state.set('fromAvailableStoreClick', action.payload);
    case PRODUCT_PICKUP_ACTIONS_CONSTANTS.FROM_AVAILABLE_STORES_CLICK_RESET:
      return state.set('fromAvailableStoreClick', false);
    case PRODUCT_PICKUP_ACTIONS_CONSTANTS.SET_FROM_RECOMMENDATIONS_QV:
      return state.set('isRecommendationsQV', action.payload);
    case PRODUCT_PICKUP_ACTIONS_CONSTANTS.GET_STORE_SPECIFIC_INVENTORY_SUCCESS:
      return state.set('storeSpecificInventory', action.payload);
    default:
      if (state instanceof Object) {
        return fromJS(state);
      }
      return state;
  }
};

export default ProductPickupReducer;
